class CartScrollableContent extends CustomElement {}

customElements.define("cart-scrollable-content", CartScrollableContent);

class CartIconBubble extends CustomButton {
  onLoad(isLoading) {
    super.onLoad(isLoading);

    this.disabled = !!isLoading;
  }

  onDisabledChange(isDisabled) {
    this.$el[!!isDisabled ? "addClass" : "removeClass"]("is-disabled");
  }
}

customElements.define("cart-icon-bubble", CartIconBubble);

class CartDrawer extends CustomElement {
  constructor() {
    super();

    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );
    this.querySelector("#CartDrawer-Overlay").addEventListener(
      "click",
      this.close.bind(this)
    );
    this.setHeaderCartIconAccessibility();
  }

  get refs() {
    return {
      scrollableContent: this.$el.find("cart-scrollable-content").get(0),
      cartItems: this.querySelector("cart-drawer-items"),
      cartUpsell: this.querySelector("cart-upsell"),
      cartIconBubble: document.getElementById("cart-icon-bubble"),
    };
  }

  async mounted() {}

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector("#cart-icon-bubble");
    cartLink.setAttribute("role", "button");
    cartLink.setAttribute("aria-haspopup", "dialog");
    cartLink.addEventListener("click", (event) => {
      event.preventDefault();
      window.location.assign("/cart");
    });
  }

  loadScript(url) {
    return new Promise((resolve, reject) => {
      const script = document.createElement("script");
      script.src = url;
      script.defer = true;
      script.onload = resolve;
      script.onerror = reject;
      document.body.appendChild(script);
    });
  }

  async sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  async open(triggeredBy) {
    this.querySelector("#CartDrawer-Loading").style.display = "none";
    this.querySelector("#CartDrawer-Content").style.display = "grid";

    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute("role"))
      this.setSummaryAccessibility(cartDrawerNote);

    setTimeout(() => {
      this.classList.add("animate", "active");
      this.querySelector(".drawer").classList.add("animate", "active");
    });

    this.addEventListener(
      "transitionend",
      () => {
        const containerToTrapFocusOn = document.getElementById("CartDrawer");
        const focusElement =
          this.querySelector(".drawer") || this.querySelector(".drawer__close");
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add("no-scroll");
  }

  close() {
    this.classList.remove("active");
    this.querySelector(".drawer").classList.remove("active");
    removeTrapFocus(this.activeElement);
    document.body.classList.remove("no-scroll");
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute("role", "button");
    cartDrawerNote.setAttribute("aria-expanded", "false");

    if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
      cartDrawerNote.setAttribute(
        "aria-controls",
        cartDrawerNote.nextElementSibling.id
      );
    }

    cartDrawerNote.addEventListener("click", (event) => {
      event.currentTarget.setAttribute(
        "aria-expanded",
        !event.currentTarget.closest("details").hasAttribute("open")
      );
    });

    cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.getSectionsToRender().forEach((section) => {
      const sectionElement =
        document.getElementById(section.id).querySelector(section.selector) ||
        document.getElementById(section.id);

      sectionElement.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.section],
        section.selector
      );
    });

    setTimeout(() => {
      this.querySelector("#CartDrawer-Overlay").addEventListener(
        "click",
        this.close.bind(this)
      );
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: "shopify-section-cart-drawer-header",
        section: "cart-drawer-header",
        selector: ".drawer-header",
      },
        {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.cart-icon-bubble',
      },
      {
        id: "shopify-section-cart-drawer-upsell",
        section: "cart-drawer-upsell",
      },
    ];
  }

  getSectionDOM(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  onLoad(isLoading) {
    this.$el[!!isLoading ? "addClass" : "removeClass"]("is-loading");
  }
}

customElements.define("cart-drawer", CartDrawer);

class CartUpsell extends CustomElement {
  props = {
    value: null,
    options: [],
    quantity: 0,
    index: 0,
    productId: 0,
  };

  get refs() {
    return {
      allAddButtons: this.$el.find("button"),
      allVariantSelectors: this.$el.find("variant-selector"),
    };
  }

  mounted() {
    let observer = new MutationObserver(this.onMutation.bind(this));

    observer.observe(this, {
      childList: true,
      subtree: true,
      characterDataOldValue: true,
    });

    this.initSwiper();

    this.$el.find("button").click(this.onAddUpsell);
  }

  async initSwiper() {
    const splide = this.querySelector(".splide");

    if (!splide) return;

    await ResourceCoordinator.requestVendor("Splide");

    new Splide(splide, {
      arrows: false,
      destroy: false,
      pagination: false,
      padding: { right: "2.5rem" },
      perPage: 1,
      perMove: 1,
      gap: "16px",
      mediaQuery: "min",
      breakpoints: {
        768: {
          arrows: false,
          destroy: true,
          pagination: false,
        },
      },
    }).mount();
  }

  onMutation(mutationRecords) {
    const cartUpsellRecord = mutationRecords.find((r) =>
      $(r.target).hasClass("cart-upsell")
    );

    if (!!cartUpsellRecord) {
      const swiper = $(cartUpsellRecord.target).find(".swiper");
      if (!swiper.hasClass("swiper-initialize")) {
        this.initSwiper();

        this.$el.find("button").click(this.onAddUpsell);
      }
    }
  }

  async onAddUpsell(e) {
    e.stopPropagation();

    const $cartUpsell = $(this).closest("cart-upsell");
    const $upsellItem = $(this).closest("cart-upsell-item");
    const $upsellVariantSelector = $upsellItem.find(".variant-selector select");

    const variantId = $upsellVariantSelector.find(":selected").val();

    const scrollableContentEl = $(this)
      .closest("cart-scrollable-content")
      .get(0);
    scrollableContentEl.loading = true;
    await $cartUpsell[0].addToCart(variantId, 1, {});
    scrollableContentEl.loading = false;
  }

  async addToCart(variantId, qty, properties = {}) {
    const data = {
      id: variantId,
      quantity: qty,
      properties,
    };

    return this.requestCart(data, routes.cart_add_url);
  }

  getSectionsToRender() {
    return [
      {
        id: "shopify-section-cart-drawer-header",
        section: "cart-drawer-header",
        selector: ".drawer-header",
      },
      {
        id: "shopify-section-cart-drawer-upsell",
        section: "cart-drawer-upsell",
      },
    ];
  }
  getSectionInnerHTML(html, selector = ".shopify-section") {
    const el = new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector);

    return el?.innerHTML ?? "";
  }

  refreshSections(state) {
    this.getSectionsToRender().forEach((section) => {
      const elementToReplace =
        document.getElementById(section.id).querySelector(section.selector) ||
        document.getElementById(section.id);

      elementToReplace.innerHTML = this.getSectionInnerHTML(
        state.sections[section.section],
        section.selector
      );
    });
  }

  async requestCart(payload = {}, url = routes.cart_change_url) {
    try {
      const cartState = await fetch(`${url}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: `application/json`,
        },
        body: JSON.stringify({
          ...payload,
          sections: this.getSectionsToRender().map(
            (section) => section.section
          ),
          sections_url: window.location.pathname,
        }),
      }).then((res) => res.json());

      const { isGWP, state: cartWithGiftState } = await updateCartGift({
        sections: this.getSectionsToRender().map((section) => section.section),
        sectionUrl: window.location.pathname,
      });

      let state = isGWP ? cartWithGiftState : cartState;

      if (state.item_count === 0) await this.emptyCart();

      this.refreshSections(state);

      return state;
    } catch (e) {
      console.log(e);
    }
  }

  async requestCartWithoutRendering(
    payload = {},
    url = routes.cart_change_url
  ) {
    try {
      await fetch(`${url}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: `application/json`,
        },
        body: JSON.stringify({
          ...payload,
          sections: this.getSectionsToRender().map(
            (section) => section.section
          ),
          sections_url: window.location.pathname,
        }),
      }).then((res) => res.json());
    } catch (e) {}
  }

  onDisabledChange(isDisabled) {
    super.onDisabledChange(isDisabled);

    const { allAddButtons, allVariantSelectors } = this.refs;

    if (isDisabled) {
      allAddButtons.attr("disabled", true);
      allVariantSelectors.attr("disabled", true);
    } else {
      allAddButtons.attr("disabled", false);
      allVariantSelectors.attr("disabled", false);
    }
  }
}

customElements.define("cart-upsell", CartUpsell);

class CartUpsellItem extends CustomElement {
  beforeMount() {
    super.beforeMount();
    const variantSelector = this.querySelector("variant-selector");
    if (variantSelector)
      variantSelector.addEventListener("change", this.refreshPrice.bind(this));
  }

  refreshPrice() {
    const $selectedOption = this.$el.find(":selected");
    const $pricingEl = this.$el.find(".upsell-item__pricing");

    const price = $selectedOption.data("price");
    const originalPrice = $selectedOption.data("originalPrice");
    const priceInCurrency = currencyFormatter.format(price);
    const originalPriceInCurrency = currencyFormatter.format(originalPrice);

    $pricingEl.html(`
      <div class="${
        originalPrice > price ? "text-[#F03306]" : ""
      } font-semibold">${priceInCurrency}</div>
      ${
        originalPrice > price
          ? `<div class="text-[#2E2F3C] line-through">${originalPriceInCurrency}</div>`
          : ""
      }
    `);
  }
}

customElements.define("cart-upsell-item", CartUpsellItem);
